import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import { $t } from "@/lib/i18nHelpers";

type LocationNamePart = "city" | "state" | "country";
type GetLocationNameOptions = {
  order?: LocationNamePart[];
};

export function getCountryName(countryCode: string) {
  return $t(`$locations.${countryCode}`);
}

export function getStateName(stateCode: string, countryCode: string) {
  return $t(`$locations.${countryCode}___${stateCode}`);
}

export function getLocationName(location: BlockedLocationAutocomplete, options: GetLocationNameOptions = {}) {
  const country = location.countryCode ? getCountryName(location.countryCode) : "";
  const state =
    location.stateCode && location.countryCode ? getStateName(location.stateCode, location.countryCode) : "";
  const city = location.city || "";
  const partsMap: Record<LocationNamePart, string> = {
    city,
    state,
    country,
  };

  const order = options.order || (["country", "state", "city"] as LocationNamePart[]);

  return order
    .map(part => partsMap[part])
    .filter(Boolean)
    .join(", ");
}
